import React from 'react';

import { cls } from '@mssgme/helpers';
import { RowProps } from './types';

import styles from './Row.scss';

export default function Row({ align, ...rest }) {
    return <div {...cls([styles.root, { [styles.right]: align === 'right' }], rest)} />;
}

Row.propTypes = RowProps;
